import React from "react";
import { LabeledDate, LabeledScrollableText, LabeledText, getFileInfo } from "sprint-common-web";

import { DeliveryType } from "../../../types/DeliveryType";
import { formatBytes } from "../../../utils/formatBytes";
import { AsperaDeliveryItem } from "../DeliveryItem";

export interface AsperaDeliveryInfoAsideContentProps {
    delivery: AsperaDeliveryItem;
}

export const AsperaDeliveryInfoAsideContent: React.FunctionComponent<AsperaDeliveryInfoAsideContentProps> = (
    props: AsperaDeliveryInfoAsideContentProps
) => {
    const { delivery } = props;

    const fileSize = delivery.file.size ? formatBytes(delivery.file.size) : undefined;
    const { name: fileName, extension: fileExtension } = getFileInfo(delivery.file.path);

    return (
        <>
            <LabeledText label="Delivery type" value={DeliveryType[delivery.type]} />
            <LabeledText label="File name" value={`${fileName}.${fileExtension}`} textTooltip={true} />
            <LabeledText label="File size" value={fileSize} />
            <LabeledDate label="Arrival date" value={new Date(delivery.file.arrivalDate)} />
            <LabeledText label="Name" value={delivery.sender?.name} textTooltip={true} />
            <LabeledText label="Email" value={delivery.sender?.email} textTooltip={true} />
            <LabeledText label="Subject" value={delivery.sender?.subject} textTooltip={true} />
            <LabeledScrollableText
                height={delivery.sender.message?.length ? 100 : 20}
                label="Message"
                value={delivery.sender?.message || "-"}
            />
            <LabeledText label="File id" value={delivery.asperaInfo.fileId} textTooltip={true} />
            <LabeledText label="Inbox id" value={delivery.asperaInfo.inboxId} textTooltip={true} />
            <LabeledText label="Inbox Name" value={delivery.asperaInfo.inboxName} textTooltip={true} />
            <LabeledText label="Package id" value={delivery.asperaInfo.packageId} textTooltip={true} />
            <LabeledText label="Package file id" value={delivery.asperaInfo.packageFileId} textTooltip={true} />
            <LabeledText label="Package deleted" value={delivery.asperaInfo.packageIsDeleted ? "yes" : "no"} />
        </>
    );
};
